var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-container"},[_c('detail',{attrs:{"data":_vm.detailData,"checkState":_vm.checkState,"date":_vm.date}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }